const getters = {
  // user  当前选择的信息
  permissions: state => state.user.permissions,
  authorization: state => state.user.authorization,
  user: state => state.user.user,
  areaAll: state => state.user.areaAll,
  userSelfAreaId: state => state.user.selfAreaId,
  userSelfAddress: state => state.user.selfAddress,
  userCurrentPage: state => state.user.userCurrentPage,
  userLevel: state => state.user.level, // 当前区域的 level
  areaLevel: state => state.user.user.areaLevel, // 当前用户的 level
  siteMessageLength: state => state.user.siteMessageLength,
  historyData: state => state.user.historyData,
  fullPileNum: state => state.user.fullPileNum, // 满装值
  fullPileName: state => state.user.fullPileName,
  sideBarLoading: state => state.user.sideBarLoading,
  isAggregation: state => state.user.isAggregation,
  userSelectAddressData: state => state.user.userSelectAddressData,
  illegalBikes: state => state.user.illegalBikes,
  // globalVariable 当前登录用户的信息
  ratioSites: state => state.globalVariable.ratioSites,
  currpath: state => state.globalVariable.currpath,
  globaleSelfAreaId: state => state.globalVariable.selfAreaId,
  siteMessage: state => state.globalVariable.siteMessage,
  globalSelfAddress: state => state.globalVariable.selfAddress,
  nationalArea: state => state.globalVariable.nationalArea, // 全国地址
  brands: state => state.globalVariable.brands, // 全国品牌
  dispatcherList: state => state.globalVariable.dispatcherList, // 调度员
  replyTypeList: state => state.globalVariable.replyTypeList,
  tableDataBrands: state => state.globalVariable.tableDataBrands,
  // 组合
  selfAreaId: state => (state.user.selfAreaId || state.globalVariable.selfAreaId),
  selfAddress: state => (state.user.selfAddress || state.globalVariable.selfAddress),
  platformCode: state => (state.user.platformCode || state.user.user.platformCode),
  userBikeType: state => state.user.userBikeType
}
export default getters
